const modalSizeToClassMap = {
  medium: 'c-modal--medium',
  large: 'c-modal--large',
};

export const MODAL_SIZES = Object.keys(modalSizeToClassMap);
export const MODAL_CLASS_MAP = {
  size: modalSizeToClassMap,
};
